import { observable } from 'mobx';
import { persist } from 'mobx-persist';
import { CmsAuthorizationEnum } from '../../enum/cms-authorization.enum';

export class AuthorizationSettingsModel {
  @persist @observable cmsUse: boolean = false;
  @persist @observable cmsRole: CmsAuthorizationEnum = CmsAuthorizationEnum.None;
  @persist @observable cmsAdvancedContentUse: boolean = false;
}
